interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (n: number) => void;
}

export const PaginationControl: React.FC<PaginationProps> = ({
  page,
  totalPages,
  onPageChange,
}) => {
  if (totalPages <= 1) return null;

  return (
    <div className="flex justify-center mt-6 gap-3">
      <button
        onClick={() => onPageChange(page - 1)}
        disabled={page === 1}
        className="px-3 py-2 bg-gray-200 rounded disabled:bg-gray-100"
      >
        Prev
      </button>

      <span className="px-3 py-2 font-semibold">
        Page {page} of {totalPages}
      </span>

      <button
        onClick={() => onPageChange(page + 1)}
        disabled={page === totalPages}
        className="px-3 py-2 bg-gray-200 rounded disabled:bg-gray-100"
      >
        Next
      </button>
    </div>
  );
};
